import { TLCEventManager } from "../../../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../../../js/lib/events/events";
import { TLCLogger } from "../../../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../../../js/main/constants";
import { ApplicationData } from "../../../ApplicationData";
import { CurrentLoansClientManager } from "../../../ClientManagers/CurrentLoansClientManager";
import { LS2PAC_Utils } from "../../../utils/Utils";
import { ResourceUtils } from "../../../utils/resourceUtils";
import { MyAccountBaseSubView } from "../BaseSubView";
import { AccountHolder } from "@tlc/ls2pac/components/Account";

export class LoansView extends MyAccountBaseSubView {
  constructor(options) {
    options = options || {};
    options.template = "tmpl/myAccount/accountActivity/loans.html";
    options.itemsTemplate = "tmpl/myAccount/accountActivity/loansItems.html";
    options.viewName = LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.loans;
    options.id = options.viewName;
    options.countField = "loanCount";
    options.dataFieldName = "loans";
    options.tabText =
      ApplicationData.language.loans +
      ' <span id="' +
      options.id +
      '_tab_count"></span>';
    /*TODO tab text should prob. be created the same way so you don't have to delete parens from all different classes when you take them out.
     * also, it would be better if the navigation container were rendered the same way instead of in 2-3 different templates so you don't have to
     * manually add the sideNav class each time.
     */
    options.addBookJackets = true;
    options.bookJacektIdSuffix = "_loans_bookJacket";
    options.ratingsSuffix = "currentLoans_ratingsControl_";

    options.sortOptions = [
      {
        sortValue: "Status",
        sortText:
          ApplicationData.language.sortBy +
          " " +
          ApplicationData.language.status,
      },
      {
        sortValue: "Title",
        sortText:
          ApplicationData.language.sortBy +
          " " +
          ApplicationData.language.title,
      },
      {
        sortValue: "Author",
        sortText:
          ApplicationData.language.sortBy +
          " " +
          ApplicationData.language.author,
      },
    ];

    super(options);
  }
  getClientManager(){
    return CurrentLoansClientManager.getInstance({
      resultsPanelId: this.id,
    });
  }
  updateLoanCount(count) {
    $("#" + LS2PAC_CONSTANTS.Ids.MyAccountPage.loanCount).text(count);
  }
  updateOverdueCount(count) {
    $("#" + LS2PAC_CONSTANTS.Ids.MyAccountPage.overdueCount).text(count);
  }
  fetchData() {
    this.clientManager.setTotalHits(this.accountSummary.patron.loanCount);
    this.updateLoanCount(this.accountSummary.patron.loanCount);
    this.updateOverdueCount(this.accountSummary.patron.itemsOverdue);
    TLCEventManager.fireEvent(this.clientManager.searchEvent);
  }
  addEvents() {

    const loanItem = $("#" + this.id);

    this.addEventHandler(loanItem, "click", ".renewLoan", (event) => {
      const loanToRenew = this.getDataItemFromIndex($(event.currentTarget));
      this.renewLoans([loanToRenew]);
      return false;
    });

    this.addEventHandler(loanItem, "click",  ".eresource-download", (event) => {
      event.currentLoan = this.getDataItemFromIndex($(event.currentTarget));

        if (event.currentLoan.eresourceService === "overdrive") {
          TLCEvents.trigger(
            LS2PAC_CONSTANTS.Events.onAttemptOverdriveDownload,
            event
          );
        } else {
          if (event.currentLoan.formatInfo.length == 1) {
            event.format = event.currentLoan.formatInfo[0].formatId;
          }

          TLCEvents.trigger(
            LS2PAC_CONSTANTS.Events.onAttemptEResourceFormatSelection,
            event
          );
        }

        return false;
    });

    this.addEventHandler(loanItem, "click", ".eresource-return", (event) => {
      event.currentLoan = this.getDataItemFromIndex($(event.currentTarget));

      if (event.currentLoan.formatInfo.length == 1) {
        event.format = event.currentLoan.formatInfo[0].formatId;
      }

      // console.log("Return clicked", event);
      TLCEvents.trigger(
        LS2PAC_CONSTANTS.Events.onAttemptEResourceReturn,
        event
      );

      return false;
    });

    this.addEventHandler(loanItem, "click", ".eresource-renew", (event) => {
      const loanToRenew = this.getDataItemFromIndex($(event.currentTarget));

      this.renewLoans([loanToRenew]);
      return false;
    });

    this.addEventHandler($("#" + this.id), "click", ".renewSelected", (event) => {
      $(event.currentTarget).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
      $(event.currentTarget).prop('disabled', true);
      //_this.getSelectedItems();
      this.renewLoans(this.getSelectedItems());
      return false;
    });

  }
  renewLoans(loans) {
    LS2PAC_Utils.renewLoanLogic(loans);
  }
  addListeners() {

    this.addListener(LS2PAC_CONSTANTS.Events.onRenewLoansResponse, (event) => {
      TLCLogger.log("onRenewLoansResponse", event);
      $("#" + this.id)
        .find(".renewSelected")
        .each(function () {
          $(event.currentTarget).removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
          $(event.currentTarget).prop('disabled', false);
        });
      this.handleBatchFeedback(
        event,
        ApplicationData.language.loanRenewError,
        ApplicationData.language.loanRenewSuccess
      );
    });
  }
  /**
   *  Helper functions.  This override functions in the parent class
   */
  async handleSuccessState(successfulItems) {
    // force a re-fetch of account summary counts
    const {patron} = await AccountHolder.fetchAccountSummaryAndPatron(true);
    this.updateLoanCount(patron.loanCount);
    this.updateOverdueCount(patron.overdueCount);
    LS2PAC_Utils.handleLoanRenewSuccess(successfulItems);
  }
  getResponseStringById(loanResponse) {
    var title = "";
    $.each(this.pageData[this.dataFieldName], function (index, loan) {
      if (loan.itemId == loanResponse.itemId) {
        title = loan.title;
        return false;
      }
    });
    return title;
  }
  manipulateData() {
    var data = this.pageData[this.dataFieldName];
    $.each(data, function (index, loan) {
      if (loan.dueDate) {
        if (typeof loan.dueDate == "string") {
          loan.dueDate = loan.dueDate.replace(/-/g, "/");
        }

        if (loan.resource && loan.resource.downloadable) {
          loan.dueDateString = LS2PAC_Utils.getDateAndTimeString(loan.dueDate);
        } else {
          loan.dueDateString = LS2PAC_Utils.getDateString(loan.dueDate);
        }

        if (loan.eresourceId != null) {
          loan.itemId = loan.eresourceId;
        }

        for (var i = 0, len = loan.formatInfo.length; i < len; i += 1) {
          var format = loan.formatInfo[i];
          format.formatName = format.formatId;

          if (
            format.formatToken &&
            format.formatToken != "<InvalidEResourceFormat>"
          ) {
            format.formatName = ResourceUtils.getMessageByMessageTokenString(
              format.formatToken
            );
          }
        }

        loan.eResourceFormats = loan.formatInfo;

        if (loan.resource && loan.resource.shortTitle) {
          loan.shortTitle = loan.resource.shortTitle;
        } else {
          loan.shortTitle = loan.title;
        }

        loan.expirationDate = new Date(loan.dueDate);
        loan.expirationDateWithFormat = loan.expirationDate.format(
          ApplicationData.language.dateFormat
        );
      }
    });
  }
}
